import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { deleteMyDiscount } from "../../api/discounts";
import { Discount } from "@/types/global";

export function ToggleDiscountModal({
  discount,
  isOpen,
  onClose,
  refetch,
}: {
  discount: Discount;
  isOpen: boolean;
  onClose: () => void;
  refetch: () => void;
}) {
  const isDeactivating = discount.active;
  const action = isDeactivating ? "desativar" : "reativar";
  const actionTitle = isDeactivating ? "Desativar" : "Reativar";

  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Deseja {action} o desconto {discount.name}?
        </ModalHeader>
        <ModalBody>
          <Text>
            {isDeactivating
              ? "Uma vez desativado, será necessária a aprovação da Partiu para reativá-lo."
              : "O desconto será reativado e ficará disponível novamente para os usuários."}
          </Text>
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button variant="ghost" onClick={() => onClose()} colorScheme="blue">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              deleteMyDiscount(discount.id).then(() => {
                refetch();
                onClose();
              });
            }}
            colorScheme={isDeactivating ? "red" : "green"}
          >
            {actionTitle}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
